module.exports = __webpack_public_path__ + "components/dropdown-search-combo/static/icon-search-white-b260935d6f0ab93f7aee6f2cc26eb40b.svg";